import { Fragment, useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminGuard } from './guards/RolesGuard';
import { UserGuard } from './guards/UserGuard';
import { routes } from './router/routes';
import RouteWrapper from './router/RouteWrapper';
import { navigationAgents } from './utils/navigation-constants/navigation-partner';
 
const App = () => {
    const redirectNotExistingRoutes = UserGuard() ? '/' : '/login'
    const [redirectPartner, setRedirectPartner] = useState<any>()
    const token = localStorage.getItem('accessToken');
    const navigation: any = navigationAgents
 
    useEffect(() => {
        if (navigation && token && (!redirectPartner || redirectPartner === '/login')) {
            const findIfInsightsExists = (navigation && navigation?.length > 0) && navigation?.find((item: any) => item?.path === '/')
            if (!findIfInsightsExists) {
                const getFirstPage = (navigation && navigation?.length > 0) && navigation?.[0]
                setRedirectPartner(getFirstPage?.path)
            } else if (!AdminGuard()) {
                setRedirectPartner('/')
            }
        }
        else if (!token && !redirectPartner) {
            setRedirectPartner('/login');
            // (window as any).Intercom('shutdown');
        }
    }, [navigation, token])

    return (
        <div className='App font-inter'>
            <Routes>
                {routes?.map((route: any, index: number) => {
                    const children = route?.childrens
                    return (
                        children ? (
                            <Fragment key={index}>
                                {route.index && <Route
                                    path={route.path}
                                    element={<Navigate to={route.index} replace />}
                                />}
                                <Route path={route.path} element={<RouteWrapper guard={route.guard} element={route.element} />}>
                                    {children?.map((r: any, i: number) => {
                                        return (
                                            <Route key={i} path={r.path} element={<RouteWrapper guard={r.guard || route.guard} element={r.element} />} />
                                        )
                                    }
                                    )}
                                </Route>
                            </Fragment>
                        ) : (
                            <Route
                                key={index}
                                path={route.path}
                                element={<RouteWrapper guard={route.guard} element={route.element} />}
                            />
                        )
                    )
                }
                )}
                <Route path='*' element={<Navigate replace to={token ? redirectPartner || redirectNotExistingRoutes || '/login' : '/login'} />} />
            </Routes>
        </div>
    );
}

export default App;
